import { render, staticRenderFns } from "./ClaimFrameSteps.vue?vue&type=template&id=79e793ff&scoped=true&"
import script from "./ClaimFrameSteps.vue?vue&type=script&lang=js&"
export * from "./ClaimFrameSteps.vue?vue&type=script&lang=js&"
import style0 from "./ClaimFrameSteps.vue?vue&type=style&index=0&id=79e793ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e793ff",
  null
  
)

export default component.exports